// extracted by mini-css-extract-plugin
export default {"confirmWidgetContainer":"ConfirmWidgetContainer_confirmWidgetContainer__letsi"};